document.addEventListener('DOMContentLoaded', () => {
  // 機能: スケジュール（一括版）テーブルの自動スクロール
  // 概要: ページロード時、横スクロール可能なテーブルを当月表示位置まで移動させる。
  //       当月の列が、スクロールで見えている領域の右端に表示されるように調整する。

  // ターゲット要素のセレクタ定義
  const TABLE_SELECTOR = '.js-adminSchedules';
  const CURRENT_MONTH_HEADER_SELECTOR = '.is-current';
  const SCROLL_CONTAINER_SELECTOR = '.table-responsive';

  const adminScheduleTable = document.querySelector(TABLE_SELECTOR);

  if (adminScheduleTable) {
    const currentMonthHeader = adminScheduleTable.querySelector(CURRENT_MONTH_HEADER_SELECTOR);

    // 必須要素（当月ヘッダー）の存在チェック
    if (currentMonthHeader) {
      const scrollContainer = adminScheduleTable.closest(SCROLL_CONTAINER_SELECTOR);

      if (scrollContainer) {
        // ページの描画が完全に安定してから位置を計算するために少し待つ
        setTimeout(() => {
          // 1. 目標要素（当月）の右端の位置を、テーブル全体の左端から計算
          const targetRightEdge = currentMonthHeader.offsetLeft + currentMonthHeader.offsetWidth;

          // 2. 表示領域の幅を取得
          //    clientWidthはスクロールバーを除いた内側の幅を取得できるため、より正確
          const containerWidth = scrollContainer.clientWidth;

          // 3. 目標スクロール位置を算出
          //    目標の右端が表示領域の右端に来るように、表示領域の幅だけ手前に戻す
          const desiredScrollLeft = targetRightEdge - containerWidth;

          // スクロールコンテナの水平スクロール位置を設定
          // 計算結果が負の値になる場合は0にする
          scrollContainer.scrollLeft = Math.max(0, desiredScrollLeft);
        }, 100);
      }
    }
  }
});